"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
class AuthApi {
    constructor(api) {
        this.api = api;
        this.api.axiosGo.interceptors.response.use(data => data, (error) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            error = this.sanitizeError(error);
            console.log('[Axios][Interceptor] Response Error', error);
            this.api.logError(error);
            const res = error.response;
            const errorMessage = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.error) !== null && _b !== void 0 ? _b : '';
            // customer api token expired error
            if ((res === null || res === void 0 ? void 0 : res.status) === 401 && errorMessage.includes('error.token.expired')) {
                // customer token expired
                if (this.api.refreshCustomerApiCallback != null) {
                    try {
                        yield this.api.refreshCustomerApiCallback();
                        // retry with new token
                        error.config.headers.Authorization = this.api.axiosGo.defaults.headers.common.Authorization;
                        return yield this.api.axiosGo.request(error.config);
                    }
                    catch (error) {
                        return yield Promise.reject(error);
                    }
                }
                return;
            }
            // orderapp token expired error
            if ((res === null || res === void 0 ? void 0 : res.status) === 406 && errorMessage === 'token expired') {
                if (this.api.refresh != null) {
                    const user = yield this.refresh(this.api.refresh);
                    if (this.api.updateUserCallback != null) {
                        yield this.api.updateUserCallback(user);
                    }
                    // retry with new token
                    error.config.headers.Authorization = this.api.axiosGo.defaults.headers.common.Authorization;
                    return yield this.api.axiosGo.request(error.config);
                }
            }
            // other 401 error
            if ((res === null || res === void 0 ? void 0 : res.status) === 401) {
                if (this.api.resetUserCallback != null) {
                    this.api.resetUserCallback(errorMessage !== null && errorMessage !== void 0 ? errorMessage : res === null || res === void 0 ? void 0 : res.status);
                    return;
                }
            }
            return yield Promise.reject(error);
        }));
        this.api.axiosNode.interceptors.response.use(data => data, (error) => __awaiter(this, void 0, void 0, function* () {
            var _c, _d, _e, _f, _g;
            error = this.sanitizeError(error);
            console.log('[Axios][Interceptor] Response Error', error);
            this.api.logError(error);
            const res = error.response;
            const errorMessage = (_d = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : '';
            if ((res === null || res === void 0 ? void 0 : res.status) === 500 && errorMessage === 'UnauthorizedError: jwt expired') {
                if (this.api.refresh != null) {
                    const user = yield this.refresh(this.api.refresh);
                    error.config.headers.Authorization = this.api.axiosNode.defaults.headers.common.Authorization;
                    if (this.api.updateUserCallback != null) {
                        this.api.updateUserCallback(user);
                    }
                    // retry
                    return yield this.api.axiosNode.request(error.config);
                }
            }
            else if ((res === null || res === void 0 ? void 0 : res.status) === 401) {
                if (this.api.resetUserCallback != null) {
                    this.api.resetUserCallback((_g = (_f = (_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.error) !== null && _f !== void 0 ? _f : errorMessage) !== null && _g !== void 0 ? _g : res === null || res === void 0 ? void 0 : res.status);
                    return;
                }
            }
            return yield Promise.reject(error);
        }));
    }
    sanitizeError(error) {
        try {
            const data = JSON.parse(error.config.data);
            if (lodash_1.default.get(data, 'payment.payload.paymentMethod.paymentCard') != null) {
                delete data.payment.payload.paymentMethod.paymentCard;
            }
            error.config.data = JSON.stringify(data);
        }
        catch (e) { }
        return error;
    }
    scopeLogin(merchantUsername, username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/user/scopelogin';
            const data = {
                merchantUsername,
                username,
                password,
            };
            const response = yield this.api.axiosGo.post(endpoint, data);
            this.api.setToken(response.data.token, response.data.refresh);
            return response.data;
        });
    }
    register(payload = '', hash = '', client = '') {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/user/register';
            const data = { payload, hash, client };
            const response = yield this.api.axiosGo.post(endpoint, data);
            this.api.setToken(response.data.token, response.data.refresh);
            return response.data;
        });
    }
    refresh(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/user/refresh';
            const response = yield this.api.axiosGo.post(endpoint, {
                token: token,
            });
            this.api.setToken(response.data.token, response.data.refresh);
            return response.data;
        });
    }
    createCustomer() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/customer';
            const response = yield this.api.axiosGo.post(endpoint);
            return response.data;
        });
    }
}
exports.default = AuthApi;
//# sourceMappingURL=Auth.js.map